/** In this file contains the landing page UI designs and functionality **/
import constantVariables from './../../dataset/constantVariables.json';
import { useEffect } from 'react';

//Landing or Home page
export default function PrivacyPolicy(){
	
	/** To check the token exist or not **/
   useEffect(()=>{
	  const section = document.getElementById("indexPage");
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
   },[]);
	
	return (
	<><div id="indexPage">
	{/**Breadcrumb Section**/}
	<section id="BreadcrumbSec" className="d-flex align-items-center justify-content-center">
		<div className="container">
			<div className="row d-flex">
				<div className="col-lg-12 align-items-center">
					<h1>{constantVariables.landing.privacyPolicy}</h1>
				</div>
			</div>
		</div>
	</section>
	
	{/**About Section**/}
	<section className="section mb-5">
		<div className="container">
			<div className="row">  
				<div className="col-lg-8 mx-auto">  
					<div className="sectionContent">
						<h5 className="fw-bold">1. {constantVariables.landing.introduction}</h5> 
							<ul>
								<li>{constantVariables.landing.introductionText}</li>
							</ul>
						<hr/>
						
						<h5 className="fw-bold">2. {constantVariables.landing.collection}</h5> 
							<ul>
								<li>{constantVariables.landing.collection1}</li>
								<li>{constantVariables.landing.collection2}</li>
								<li>{constantVariables.landing.collection3}</li>
								<li>{constantVariables.landing.collection4}</li>
								<li>{constantVariables.landing.collection5}
								<ol style={{ listStyle: 'none' }}>
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>i) {constantVariables.landing.ques1}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara1}</span>
									</li>
									
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>ii) {constantVariables.landing.ques2}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara2}</span>
										<br/>
											<span>&nbsp;{constantVariables.landing.para1}</span>
										<br/>
											<span>&nbsp;{constantVariables.landing.para2}</span>
									</li>
									
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>iii) {constantVariables.landing.ques3}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara3}</span>
										<br/>
										<span>&nbsp;{constantVariables.landing.para3}</span>
									</li>
									
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>iv) {constantVariables.landing.ques4}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara4}</span>
										<br/>
											<span>&nbsp;{constantVariables.landing.para4}</span>
										<br/>
											<span>&nbsp;{constantVariables.landing.para5}</span>
										<br/>
											<span>&nbsp;{constantVariables.landing.para6}</span>
									</li>
									
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>v) {constantVariables.landing.ques5}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara5}</span>
									</li>
									
									<li style={{ counterIncrement: 'roman-counter', marginBottom: '1em' }}>vi) {constantVariables.landing.ques6}
									<br/>
										<span>&nbsp;{constantVariables.landing.anspara6}</span>
									</li>
								</ol>
								</li>
							</ul>
						<hr/>
						
						{/*<h5 className="fw-bold">3. {constantVariables.landing.useofInformation}</h5> 
							<ul>
								<li>{constantVariables.landing.info1}</li>
								<li>{constantVariables.landing.info2}</li>
							</ul>
						<hr/>*/}
						
						<h5 className="fw-bold">3. {constantVariables.landing.sharing}</h5> 
							<ul>
								<li>{constantVariables.landing.sharing1}</li>
							</ul>
						<hr/>
						
						<h5 className="fw-bold">4. {constantVariables.landing.security}</h5> 
							<ul>
								<li>{constantVariables.landing.security1}</li>
							</ul>
						<hr/>
												
						<h5 className="fw-bold">5. {constantVariables.landing.rights}</h5> 
							<ul>
								<li>{constantVariables.landing.rights1}</li>
							</ul>
						<hr/>
												
						<h5 className="fw-bold">6. {constantVariables.landing.childrenPrivacy}</h5> 
							<ul>
								<li>{constantVariables.landing.childrenPrivacy1}</li>
							</ul>
						<hr/>
												
						<h5 className="fw-bold">7. {constantVariables.landing.changesPP}</h5> 
							<ul>
								<li>{constantVariables.landing.changesPP1}</li>
							</ul>
						<hr/>
						
						{/*<h5 className="fw-bold">9. {constantVariables.landing.cInformation}</h5> 
							<ul>
								<li>{constantVariables.landing.cInformation1}</li>
							</ul>
						<hr/>*/}
						
					</div>
				</div>
			</div>
		</div>
	</section>
	</div></>);
}